import { render, staticRenderFns } from "./GeneSymbolBrowse.vue?vue&type=template&id=fb791c44&scoped=true"
import script from "./GeneSymbolBrowse.vue?vue&type=script&lang=js"
export * from "./GeneSymbolBrowse.vue?vue&type=script&lang=js"
import style0 from "./GeneSymbolBrowse.vue?vue&type=style&index=0&id=fb791c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb791c44",
  null
  
)

export default component.exports